module.exports = __webpack_public_path__ + "img/Scavenging.8cc910e7.png";